import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useEffect, useState } from "react";
import {
    NavLink,
    useLocation,
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
    {
        accessor: "name",
        header: "Type Master Display Name",
    },
    {
        accessor: "value",
        header: "Type Master Name",
    },
    {
        accessor: "category",
        header: "Type Master Category",
        cell: (row) => <>{row?.category?.category_name}</>,
    },
    {
        accessor: "sequence",
        header: "Sequence",
        sortable: true,
    },
    {
        accessor: "description",
        header: "Description",
    },
];

const TypeMaster = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [typeMasterEntries, setTypeMasterEntries] = useState(initialEntries);
    console.log(typeMasterEntries);
    const [typeMasterPageIndex, setTypeMasterPageIndex] = useState(
        initialPage - 1
    );
    console.log(typeMasterPageIndex);
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [typeMasterCategory, setTypeMasterCategory] = useState(null);
    const [sorting, setSorting] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: typeMasterEntries,
            page_no: typeMasterPageIndex + 1,
            event: search ? search : undefined,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            action: "category_wise",
            category_id: typeMasterCategory?.id,
            sort_q:
                sorting &&
                sorting
                    ?.map((item) => (item?.desc ? "desc" : "asc"))
                    ?.join(","),
            sort_c: sorting && sorting?.map((item) => item?.id)?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const { mutate: deleteData } = useDelete();

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setTypeMasterPageIndex(value.pageIndex);
        setTypeMasterEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-type-master", { state: { editpost: row.original } });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    const handleSortingChnage = (value) => {
        console.log(value);
        setSorting(value);
    };

    useEffect(() => {
        const category = JSON.parse(sessionStorage.getItem("TMCategory"));
        if (category) {
            setTypeMasterCategory(category);
        }
    }, []);

    if (!JSON.parse(sessionStorage.getItem("TMCategory"))) {
        Swal.fire({
            icon: "error",
            text: "Unable to find category",
        }).then(() => navigate(-1));
    }

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Type Master
                        </h3>
                    </div>
                    {privileges.includes("type_master_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-type-master"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-typemaster"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-type-master"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-typemaster"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Type Master</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data.results.data : []}
                columns={columns}
                pagination
                pageIndex={typeMasterPageIndex}
                pageSize={typeMasterEntries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                editRows={
                    privileges.includes("type_master_update") ? true : false
                }
                deleteRows={
                    privileges.includes("type_master_delete") ? true : false
                }
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
                onSortingChange={handleSortingChnage}
            />
        </>
    );
};

export default TypeMaster;
